<div
class="bg-white rounded-[16px] border-[1px] border-solid border-[#DDE4EB] mt-[45px] relative px-[27px] md:px-[75px] pt-[53px] pb-[40px] w-[min-content] mx-auto">
<div class="absolute top-[0] left-[50%] flex gap-[6px]" style="transform: translate(-50%, -50%);">
    @for (button of [1,2]; track $index) {
    <p-skeleton width="114px" height="44px" borderRadius="6px" styleClass=" button-shadow " />}
  </div>

  <div class="flex flex-col md:flex-row  gap-[12px]">
    @for (plan of getSkeletonItems(); track $index) {
    <div
      class="bg-[#F5F7FA] rounded-[12px] border-[1px] border-solid border-[#DDE4EB] px-[16px] pt-[16px] pb-[32px] w-[313px]">
      <p-skeleton width="10rem" height="1rem" styleClass="mb-4" />
      <div class="flex items-end">
        <p-skeleton width="8rem" height="2rem" styleClass="mb-3" /> <p-skeleton width="4rem" height="1rem"
          styleClass="mb-3 ms-1" />
      </div>
      <p-skeleton width="10rem" height="1rem" styleClass="mb-3" />
      <p-skeleton width="8rem" height="1rem" styleClass="mb-4" />
      <div class="border-b-[1px] border-solid border-[#DDE4EB] w-full mt-[24px] mb-[20px]"></div>
      @for (item of [1,2,3,4,5,6,7,8,9]; track $index) {
      <div class="flex items-center mb-3">
        <p-skeleton shape="circle" size="1.5rem" styleClass="me-2" />
        <p-skeleton width="12rem" height="1rem" />
      </div>
      }

    </div>



    }
  </div>
  <div class=" mx-auto w-full md:w-[60%]">
    <p-skeleton width="100%" height="1rem" styleClass="mx-auto mt-4 mb-2" />
    <p-skeleton width="100%" height="1rem" styleClass="mx-auto mb-2" />
    <p-skeleton width="50%" height="1rem" styleClass="mx-auto" />
  </div>
</div>
